const API_LIST = {
  common: {
    menuTree: 'menusCate/getKaMenusCateList.show',
    life: 'common/getSortLifeList.show',
    map: 'culturalMap/culturalContentsList.show', // 文化地图
    menu: 'common/getMenuByCurLifeCode.show',
    updateSubtanceNum: 'common/updateSubstanceNum.show',
    updateSubtancePraiseNum: 'common/updateSubstancePraiseNum.show', // 点赞
    classifyTree: 'classify/getClassifyTree.show',
    commentList: 'comment/getKaCommentList.show',
    loginPic: 'common/getLoginCode.show',
    checkPic: 'common/checkLoginCode.show', // 单独验证验证码
    checkCode: 'common/checkVerifyCodes.show', // 验证手机验证码
    carousel: 'carousel/getKaCarouselList.show', // 轮播
    indexData: 'home_setting/getKaHomeSetting.show',
    indexHeritorData: 'substance/getFHeritorAndHeritageCount.show', // 非遗数据统计
    indexVenueData: '/venue/getVenueAndFieldCount.show',
    indexHeritorList: 'substance/getHeritageList.show',
    thirdLogin: 'users/getAuthorizeCode.login',
    behavior: 'common/getUserBehavior.show',
    bindMobile: 'users/bindUserMobile.show',
    updateMobile: 'users/bindUpdateUserMobile.show',
    search: 'common/getGlobalSearch.show',
    province: 'common/getProvinceRegionList.show', // 省
    cityOrCountry: 'common/getRegionListByPareaCode.show', // 市村
    getSignature: 'common/getSignature.show',
    addComment: 'comment/insertKaComment.front', // 新增评论
    sysTime: 'common/getSystemInfo.show',
    parentMenu: 'menusCate/getKaMenusCate.show',
    getProfessionList: 'profession/getKaProfessionList.show',
    lifeCircle: 'lifeCircle/getKaLifeCircleList.show',
    resType: 'genre/getKaGenreList.show',
    SubLifeList: '/lifeCircle/getImmediateSubLifeList.show',
    feedback: '/feedback/insertKaFeedback.show',
    menuslist:'menu_cate/findMenuCateList.show',
    menus:'menu_cate/getKaMenuCate.show',
    subjectList: 'subject/findSubjectList.show',
    subject: 'subject/getKaSubject.show',
    classifyList: 'classify/getKaClassifyList.show',
    resClassList: 'res_classify/getKaResClassifyList.show'
  },
}

export default API_LIST



// WEBPACK FOOTER //
// ./src/api/config.js